export const EMAIL_LABEL = 'Email'
export const EMAIL_PLACEHOLDER = 'Enter Email Address...'
export const EMAIL_ERROR_TEXT = 'Email address is not found'
